import {
  UPDATE_TIME,
  UPDATING_TIME,
  MERCHANT_SELECTED,
  LOADING_MERCHANT,
  UPDATE_TIME_FAILED,
  UPDATE_DELIVERY_PERSONALLY,
} from '../actions';

function merchant(
  state = {
    isFetching: false,
    isUpdating: false,
    merchant: {},
  },
  action
) {
  switch (action.type) {
    case LOADING_MERCHANT:
      return {
        ...state,
        isFetching: true,
      };
    case MERCHANT_SELECTED:
      return {
        ...state,
        isFetching: false,
        merchant: { ...action.merchant },
      };
    case UPDATING_TIME:
      return {
        ...state,
        isUpdating: true,
      };
    case UPDATE_TIME:
      return {
        ...state,
        isUpdating: false,
        merchant: { ...action.merchant },
      };
    case UPDATE_TIME_FAILED:
      return {
        ...state,
        isUpdating: false,
      };
    case UPDATE_DELIVERY_PERSONALLY:
      return {
        ...state,
        isUpdating: false,
        merchant: { ...action.merchant },
      };
    default:
      return state;
  }
}

export default merchant;



// WEBPACK FOOTER //
// ./src/reducers/merchant.js